export const SUPER_PIXEL_NAMESPACE = 'SuperPixelInjector'

export const CONTEXT_NAME = 'membership_catalog'
